import { HttpService } from '../../../http.service';
import { Injectable } from '@angular/core';
import { MarketService } from './market.service';
import { Observable } from 'rxjs';
import { ResourcePriceData } from '../../../model/resourcePriceData';

@Injectable({
  providedIn: 'root'
})
export class HttpMarketService extends MarketService{

  constructor(
    private httpService: HttpService,
  ) { super(); }

  getMarketPrice(resource: string): Observable<ResourcePriceData> {
    const encodedResource = encodeURIComponent(resource);
    return this.httpService.get(`/getMarketPrice?commodity=${encodedResource}`, true);
  }

}
